// These configurations are relevant to production only.
// We do not have a HubSpot dev or stg env sandbox.
// https://legacydocs.hubspot.com/docs/methods/oauth2/oauth2-quickstart

export default {
  INTEGRATIONS_ENDPOINT: 'https://p1ursj6215.execute-api.ap-southeast-2.amazonaws.com/prod',
  HUBSPOT_CLIENT_ID: '45de9f52-45d3-4fff-9b06-df0e330f6d6f',
  HUBSPOT_APP_INSTALL_PATH: 'https://app.hubspot.com/oauth/authorize',
  HUBSPOT_REDIRECT_URI_DEV: 'app.shootsta.com', // set to prod for now as we don't have dev hb app
  HUBSPOT_REDIRECT_URI_STG: 'app.shootsta.com', // set to prod for now as we don't have stg hb app
  HUBSPOT_REDIRECT_URI_PRD: 'app.shootsta.com',
  HUBSPOT_PERMISSION_SCOPE: 'media_bridge.read%20media_bridge.write%20contacts%20tickets%20e-commerce%20crm.schemas.custom.read%20crm.objects.custom.read%20crm.objects.custom.write'
};